import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import { DegenHours } from '../model'

import type { Address } from '@root/entities/address/Address'

/**
 * The hours are the reader's own.
 *
 * Asked of the browser rather than assumed: a heatmap bucketed in UTC is off
 * by a whole row for most of the world, and wrong about which day it is for
 * everyone east of London after nine in the evening. Somewhere without a
 * timezone database falls back to UTC, which is at least a timezone rather
 * than a guess.
 */
const readerTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch {
    return 'UTC'
  }
}

export const fetchWalletDegenHoursRequestAction = action(
  async (
    ctx,
    {
      network,
      walletAddress,
      days,
    }: {
      network: Network.Network
      walletAddress: Address
      days: number
    },
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesWalletDegenHoursList, [
        {
          network: Network.toDto(network),
          walletAddress,
          timezone: readerTimezone(),
          days,
        },
      ]),
    )

    return result.pipe(
      Result.map(DegenHours.fromDto),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'fetchWalletDegenHoursRequestAction',
)
